// HOTFIX: Override price calculation event listener to load data from DOM if missing
// This fixes the mobile Safari issue where boxData is undefined
(function() {
  console.log('[HOTFIX] Price calculation fix loaded');
  
  document.addEventListener("juo-box:update-prices", async (e) => {
    // Get data from event or load from DOM
    let boxData = e.detail.data;
    
    if (!boxData) {
      const dataElement = document.getElementById('juo-box-data');
      if (dataElement) {
        const rawData = JSON.parse(dataElement.textContent);
        const prices = {};
        rawData.ids.forEach((id) => {
          const variant = rawData.variants.find((v) => v.id == id);
          if (variant) prices[id] = variant.price;
        });
        boxData = {
          prices: prices,
          tiers: rawData.tiers,
          sellingPlans: rawData.sellingPlans,
          product: rawData.product,
          freeProduct: rawData.freeProduct || {},
          variants: rawData.variants,
          minItemsCount: rawData.minItemsCount,
          moneyFormat: rawData.moneyFormat
        };
      }
    }
    
    if (!boxData || !boxData.prices) {
      console.error('[HOTFIX] Missing box data');
      return;
    }
    
    // Calculate total price
    let totalPrice = 0;
    e.detail.formValues.forEach(({ variantId, qty }) => {
      const price = boxData.prices[variantId];
      if (price && qty > 0) {
        totalPrice += price * qty;
      }
    });
    
    // Calculate discount
    const qty = e.detail.totalQty;
    let discount = 0;
    
    if (qty >= 4) {
      // 4+ items: use tier discount
      const tier = boxData.tiers
        .sort((a, b) => b.productsCount - a.productsCount)
        .find(t => t.productsCount <= qty);
      discount = tier ? tier.value : 0;
    } else if (qty > 0) {
      // 1-3 items: check toggle for member vs non-member
      const isMember = document.querySelector('input[name="pricing-type"][value="member"]')?.checked;
      discount = isMember ? 50 : 35;
    }
    
    // Calculate final prices
    const savings = parseInt(totalPrice * discount * 0.01, 10);
    const finalPrice = totalPrice - savings;
    const comparePrice = qty > 0 ? totalPrice : 0;
    
    // Format prices
    const formatter = new Intl.NumberFormat(window.Shopify.locale, { 
      style: "currency", 
      currency: window.Shopify.currency.active 
    });
    
    const finalPriceText = formatter.format(finalPrice / 100);
    const comparePriceText = (comparePrice !== finalPrice && comparePrice > 0) 
      ? formatter.format(comparePrice / 100) 
      : "";
    const savingsText = savings > 0 ? formatter.format(savings / 100) : "";
    
    // Set prices in DOM
    const totalPriceEl = document.querySelector('[data-ref="total-price"]');
    const comparePriceEl = document.querySelector('[data-ref="compare-price"]');
    const savingsEl = document.querySelector('[data-ref="savings"]');
    
    if (totalPriceEl) totalPriceEl.innerText = finalPriceText;
    if (comparePriceEl) comparePriceEl.innerText = comparePriceText;
    if (savingsEl) savingsEl.innerText = savingsText;
    
    console.log('[HOTFIX] Price set:', finalPriceText);
  });
})();
